function foreignPassportClearFormatting(input: string | null | undefined): string {
  let result = '';

  if (input == null) {
    return result;
  }

  let trimmed = input.trim();

  for (let i = 0; i < trimmed.length; i++) {
    if (trimmed[i] !== ' ') {
      result += trimmed[i];
    }
  }

  return result;
}

export default foreignPassportClearFormatting;
